'use client';

import dynamic from 'next/dynamic';
import styles from './Map.module.css';

/**
 * Lazy boundary for the map. `BywayMap` statically pulls in maplibre-gl +
 * react-map-gl (~200KB+ gzipped), so importing it directly lands the whole
 * library in the page's initial bundle. Loading it through `next/dynamic` keeps
 * maplibre in its own chunk fetched after hydration. `ssr: false` because the
 * map reads window/matchMedia and renders nothing meaningful on the server.
 *
 * Import this — not `BywayMap` — from any module reachable by an initial bundle.
 */
export const BywayMapLazy = dynamic(() => import('./Map').then((mod) => ({ default: mod.BywayMap })), {
  ssr: false,
  loading: () => <div className={styles.mapPlaceholder} aria-hidden />
});
